export const getLocale = () => document.querySelector('html').getAttribute('lang') ?? navigator.language ?? 'en-US';
export const katTranslator = strings => (stringId, options, locale, pluralOptions) => {
  let translation;
  if (pluralOptions) {
    const stringLocale = strings[stringId][locale ?? getLocale()] ?? strings[stringId]['en-US'];
    translation = stringLocale.pluralItems[pluralOptions.quantity];
    translation = translation ? translation : stringLocale.pluralItems['other'];
    pluralOptions.replacers.forEach(replacer => translation = translation.replace(new RegExp(`{${replacer[0]}.*?}`), replacer[1]));
  } else {
    translation = strings[stringId][locale ?? getLocale()];
    translation = translation ?? strings[stringId]['en-US'];
  }
  if (options) {
    Object.keys(options).forEach(key => {
      const value = options[key];
      translation = translation?.replace(new RegExp('{' + key + '}', 'g'), value);
    });
  }
  return translation;
};
//# sourceMappingURL=i18n.js.map